interface SpinnerProps {
  small?: boolean;
}

export function Spinner({ small }: SpinnerProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 20px' }}>
      <div className={`spinner${small ? ' spinner--small' : ''}`} />
    </div>
  );
}
